import React, { useEffect, useState } from "react";

import { LoadingOutlined } from "@ant-design/icons";

import NoResultsGIF from "../../../../Common/NoResultsGIF";
import StyledScrollbar from "../../../../Common/UIComponents/StyledScrollbar";

import genistaHeader from "../../../../../assets/images/environment/genistaHeader.svg";
import pumpkinGIF from "../../../../../assets/images/environment/pumpkin.gif";

import "./ExportCOADataPreview.css";

export default function ExportCOADataPreview({ filteredSamples, loading }) {
  const [samples, setSample] = useState([]);
  const [testNames, setTestNames] = useState([]);
  useEffect(() => {
    const sampleEntries = filteredSamples ? Object.values(filteredSamples) : [];
    const testName = [...new Set(
      sampleEntries.flatMap((entry) => entry.tests.map((test) => test.test_name)),
    )];
    setSample(sampleEntries);
    setTestNames(testName);
  }, [filteredSamples]);

  return (
    <div className="ExportCOADataPreview__Div">
      <img src={genistaHeader} alt="" className="ExportCOADataPreview__Genista__Header__Img" />

      <div className="ExportCOADataPreview">
        {Object.keys(filteredSamples).length > 0 && testNames && !loading && (
        <StyledScrollbar
          className="COATableScrollbar"
        >
          <div className="ExportCOADataPreview__TableContainer">
            <table className="ExportCOADataPreview__Table">
              <thead className="ExportCOADataPreview__Header">
                <tr>
                  <th className="ExportCOADataPreview__MainField">Received Date</th>
                  <th className="ExportCOADataPreview__MainField textAlignment">Sample ID</th>
                  <th className="ExportCOADataPreview__MainField">Sample Type</th>
                  {testNames?.map((test, index) => (
                    <th key={index}>{test}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {samples?.map((sample, index) => (
                  <tr key={index} className="ExportCOADataPreview__Row">
                    <td className="ExportCOADataPreview__MainField">{sample.received_date}</td>
                    <td className="ExportCOADataPreview__MainField textAlignment">{sample.sample_id}</td>
                    <td className="ExportCOADataPreview__MainField">{sample.sample_type}</td>
                    {testNames.map((testName, testIndex) => {
                    // Find the test result for this specific test name in the sample
                      const test = sample.tests.find((t) => t.test_name === testName);
                      return (
                        <td key={testIndex}>
                          {test ? test.test_result : "N/A"}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </StyledScrollbar>
        )}
        {
         filteredSamples && Object.keys(filteredSamples).length === 0 && !loading && (<NoResultsGIF image={pumpkinGIF} message="No data" className="pumpkinGIF" />)
        }
        {loading && <LoadingOutlined spin className="ExportCOADataPreview__LoadingIcon" />}
      </div>
    </div>
  );
}
